import { useContext } from "react";
import { MapStoreContext } from "../context/MapStoreContext";
import { StoreApi } from "zustand";
import { IMapStoreState } from "../stores/MapStore";

export function useMapStoreContext(): StoreApi<IMapStoreState> {
    return useContext(MapStoreContext);
}
